<mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
<div class="progress-text-content">
    <span class="progress-text" [class.is-done]="file.progress === 100">
        <span *ngIf="file.status === uploadStatus.waiting">
            {{ 'files.uploadStates.waiting.shortLabel' | translate }}…</span>
        <span *ngIf="file.status === uploadStatus.uploading">
            {{ file.progress }}% {{ 'files.uploadStates.uploading.shortLabel' | translate }}…</span>
        <span *ngIf="file.status === uploadStatus.done">
            {{ 'files.uploadStates.done.shortLabel' | translate }}</span>
        <span *ngIf="file.status === uploadStatus.fail">
            {{ 'files.processingStates.fail.summary' | translate }}</span>
        <span *ngIf="file.status === uploadStatus.invalidType">
            {{ 'files.uploadStates.typeError.fullLabel' | translate }}</span>
    </span>
</div>
